import React, { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import toyHouse from "../assets/portfolio/toyHouse.png";
import chefFinder from "../assets/portfolio/chefFinder.png";
import summerWonderland from "../assets/portfolio/summerWonderland.png";
import flixVerse from "../assets/portfolio/flixVerse.png";
import campusBooks from "../assets/portfolio/campusBooks.png";
import taskHub from "../assets/portfolio/taskHub.png";

const Portfolio = () => {
  const portfolios = [
    {
      id: 3,
      src: taskHub,
      name: "Task Hub",
      summery:
        "Task Hub is a Team Collaboration task management app. Here you can create teams and add team members. Then you can assign tasks to the team members. There are three phases for the tasks- incomplete, processing and complete.",
      technology: [
        "ReactJS",
        "React Router",
        "React Icons",
        "React Hook Form",
        "React Helmet Async",
        "Tailwind",
        "MongoDB",
        "Axios",
        "Tanstac Query",
        "Firebase",
        "Sweet Alert2",
        "JsonWebToken",
        "Express",
      ],
      liveLink: "https://task-hub-d5e54.web.app/",
      code: "https://github.com/fahimshariar28/task-hub.git",
    },
    {
      id: 4,
      src: campusBooks,
      name: "Campus Books",
      summery:
        "College Books is a user-friendly and visually appealing web application designed to streamline the process of accessing college services and facilities. As a MERN stack developer, I led the development of this platform, integrating cutting-edge technologies to create an efficient and engaging experience for visitors.",
      technology: [
        "ReactJS",
        "React Router",
        "React Icons",
        "React Hook Form",
        "React Marquee",
        "React Helmet Async",
        "Lottie Animation",
        "Tailwind",
        "MongoDB",
        "Axios",
        "Tanstac Query",
        "Firebase",
        "Sweet Alert2",
        "JsonWebToken",
        "Express",
      ],
      liveLink: "https://campus-books-892cb.web.app/",
      clintCode: "https://github.com/fahimshariar28/campus-books-client.git",
      serverCode: "https://github.com/fahimshariar28/campus-books-server.git",
    },
    {
      id: 5,
      src: flixVerse,
      name: "Flix Verse",
      summery: "The website is designed for users to watch online movies",
      technology: [
        "ReactJS",
        "React Router",
        "React Icons",
        "Redux",
        "Tailwind",
        "MongoDB",
        "Axios",
        "Tanstac Query",
        "Firebase",
        "Sweet Alert2",
        "JsonWebToken",
        "Express",
      ],
      liveLink: "https://flix-verse.web.app/",
      clintCode: "https://github.com/fahimshariar28/flix-verse-client.git",
      serverCode: "https://github.com/fahimshariar28/flix-verse-server.git",
    },
    {
      id: 6,
      src: summerWonderland,
      name: "Summer Wonderland",
      summery:
        "The website is designed for a summer camp and has three different roles: admin, instructor, and student. Each role has specific functionalities and permissions.  The student role allows users to browse and select classes they are interested in attending. They can make payments for their chosen classes and also view their payment history, providing transparency and easy access to their financial records. The instructor role enables instructors to add new classes to the website. They have the ability to create and manage class information, including class schedules, descriptions, and other relevant details. Instructors can also edit their own classes, ensuring that the information stays up to date. The admin role possesses extensive privileges and controls over the website. Administrators have the authority to change the role assignments of any user, granting or revoking specific permissions as needed. They are responsible for approving or denying class proposals submitted by instructors, ensuring the quality and appropriateness of the classes offered. Overall, the website provides a user-friendly platform for students to explore and register for summer camp classes, instructors to manage their classes efficiently, and administrators to oversee the entire process and maintain the integrity of the camp's offerings.",
      technology: [
        "ReactJS",
        "React Router",
        "React Icons",
        "React Hook Form",
        "React Helmet Async",
        "Tostify",
        "Tailwind",
        "MongoDB",
        "Axios",
        "Tanstac Query",
        "Stripe",
        "Firebase",
        "Sweet Alert2",
        "JsonWebToken",
        "Express",
        "Framer Motion",
      ],
      liveLink: "https://summer-wonderland.web.app/",
      clintCode: "https://github.com/fahimshariar28/summer-wonderland-clint",
      serverCode: "https://github.com/fahimshariar28/summer-wonderland-server",
    },
    {
      id: 7,
      src: toyHouse,
      name: "Toy House",
      summery:
        "The toy store website is designed to cater to sellers, allowing them to showcase their toys to potential customers. The website features a comprehensive list of toys available for viewing by all visitors. Each toy listing includes a Details button that provides additional information about the toy. However, to access the detailed information, users are required to log in to their accounts. Once logged in, users have the privilege of adding new toys to their inventory. They can also edit the details of their existing toys to keep the information up to date and accurate. Additionally, users have the option to remove their toys from the website if they no longer wish to sell them.",
      technology: [
        "ReactJS",
        "React Router",
        "React Hook Form",
        "React AOS",
        "NodeJS",
        "ExpressJS",
        "MongoDB",
        "Firebase",
        "Tailwind",
        "Tostify",
      ],
      liveLink: "https://toy-house-342b7.web.app/",
      clintCode: "https://github.com/fahimshariar28/toy-house-clint.git",
      serverCode: "https://github.com/fahimshariar28/toy-house-server.git",
    },
    {
      id: 8,
      src: chefFinder,
      name: "Chef Finder",
      summery:
        "Chef Finder is a dynamic website designed to connect users with talented chefs. It provides a comprehensive directory of chefs, allowing users to explore detailed profiles and discover their culinary expertise. Logged-in users can access a wide variety of delicious recipes shared by chefs, gaining inspiration for their own cooking adventures. The platform also offers the option to add recipes to a favorites list, enabling users to create a personalized collection of go-to dishes. With its user-friendly interface and focus on culinary exploration, Chef Finder offers a seamless and enjoyable experience for both chefs and food enthusiasts alike.",
      technology: [
        "ReactJS",
        "React Router",
        "React Hook Form",
        "Firebase",
        "NodeJS",
        "Express",
        "Tailwind",
      ],
      liveLink: "https://chef-finder-96398.web.app/",
      clintCode: "https://github.com/fahimshariar28/chef-finder-clint.git",
      serverCode: "https://github.com/fahimshariar28/chef-finder-server.git",
    },
  ];

  const [id, setId] = useState(null);
  const [modalData, setModalData] = useState({});
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (id) {
      const data = portfolios.find((portfolio) => portfolio.id === id);
      setModalData(data);
    }
  }, [id]);

  return (
    <div
      name="portfolio"
      className="bg-gradient-to-b from-black to-gray-800 w-full md:h-screen text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Portfolio
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {!showAll
            ? portfolios.slice(0, 3).map(({ id, src, name }) => (
                <div key={id} className=" shadow-md shadow-blue-400 rounded-lg">
                  <img
                    src={src}
                    alt=""
                    className="rounded-md duration-200 hover:scale-105"
                  />
                  <div className="flex justify-between items-center px-4 py-2">
                    <p className="text-xl font-bold">{name}</p>
                    <button
                      className="text-xl"
                      onClick={() => {
                        window.my_modal_4.showModal();
                        setId(id);
                      }}
                    >
                      <FaArrowRight />
                    </button>
                  </div>
                </div>
              ))
            : portfolios.map(({ id, src, name }) => (
                <div key={id} className=" shadow-md shadow-blue-400 rounded-lg">
                  <img
                    src={src}
                    alt=""
                    className="rounded-md duration-200 hover:scale-105"
                  />
                  <div className="flex justify-between items-center px-4 py-2">
                    <p className="text-xl font-bold">{name}</p>
                    <button
                      className="text-xl"
                      onClick={() => {
                        window.my_modal_4.showModal();
                        setId(id);
                      }}
                    >
                      <FaArrowRight />
                    </button>
                  </div>
                </div>
              ))}
        </div>
        {portfolios?.length > 3 && (
          <div className="flex justify-center mt-8">
            <button
              className="btn btn-primary"
              onClick={() => {
                setShowAll(!showAll);
              }}
            >
              {<span>{showAll ? "Show Less" : "Show All"} </span>}
            </button>
          </div>
        )}
      </div>
      <dialog id="my_modal_4" className="modal">
        <form method="dialog" className="modal-box w-11/12 max-w-5xl">
          {
            <div className="flex flex-col justify-center items-center">
              <img
                src={modalData.src}
                alt=""
                className="rounded-md duration-200 hover:scale-105"
              />
              <div className="flex justify-between items-center px-4 py-2">
                <p className="text-2xl font-bold text-cyan-400">
                  {modalData.name}
                </p>
              </div>
              <p className="text-xl font-bold text-cyan-400 mt-3">
                Summery: <span className="text-white">{modalData.summery}</span>
              </p>
              <p className="text-xl font-bold text-cyan-400 mt-3">
                Technology Used:{" "}
                {modalData?.technology?.map((tech, index) => (
                  <span key={index} className="text-white">
                    {tech},{" "}
                  </span>
                ))}{" "}
              </p>
              <div className="flex justify-around gap-20 px-4 py-2 text-cyan-400">
                <a
                  href={modalData.liveLink}
                  target="_blank"
                  rel="noreferrer"
                  className="text-xl inline"
                >
                  Live Link
                </a>
                {modalData.clintCode && modalData.serverCode ? (
                  <>
                    <a
                      href={modalData.clintCode}
                      target="_blank"
                      rel="noreferrer"
                      className="text-xl inline"
                    >
                      Client Code
                    </a>
                    <a
                      href={modalData.serverCode}
                      target="_blank"
                      rel="noreferrer"
                      className="text-xl inline"
                    >
                      Server Code
                    </a>
                  </>
                ) : (
                  <>
                    <a
                      href={modalData.code}
                      target="_blank"
                      rel="noreferrer"
                      className="text-xl inline"
                    >
                      Source Code
                    </a>
                  </>
                )}
              </div>
            </div>
          }
          <div className="flex justify-center">
            <button className="btn btn-primary">Close</button>
          </div>
        </form>
      </dialog>
    </div>
  );
};

export default Portfolio;
